module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('h1', {
    staticClass: "subtitle"
  }, [_vm._v("THE INVISIBLE"), _c('br'), _vm._v(" INFLUENCE")]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle1"
  }, [_vm._v("A STORY OF THE MYSTIC ORIENT WITH "), _c('br'), _vm._v("GREAT TRUTHS WHICH CAN NEVER DIE")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("By"), _c('br'), _c('span', {
    staticClass: "big23"
  }, [_vm._v("ALEXANDER CANNON")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("M.D., D.P.M., PH.D., M.A., F.R.G.S., ETC."), _c('br'), _vm._v("AUTHOR OF “HYPNOTISM”"), _c('br'), _vm._v("SENIOR AUTHOR OF “THE PRINCIPLES AND PRACTICE OF PSYCHIATRY,”"), _c('br'), _vm._v("“THE PRINCIPLES AND PRACTICE OF NEUROLOGY,” ETC.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fb58e3c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/tp.vue
// module id = 57
// module chunks = 0